export default "__VITE_ASSET__dde71844__"